import { supabase } from "@/integrations/supabase/client";

/**
 * Sends notifications to all users with the targeted roles
 * when a survey is published, using a dedicated security-definer function.
 */
export async function sendSurveyNotifications(
  surveyTitle: string,
  targetRoles: string[],
  surveySlugOrId: string,
  isPublic: boolean
) {
  if (!targetRoles.length) return;

  try {
    const { error } = await supabase.rpc("notify_survey_published" as any, {
      _survey_title: surveyTitle,
      _target_roles: targetRoles,
      _survey_slug_or_id: surveySlugOrId,
      _is_public: isPublic,
    });

    if (error) {
      console.error("Failed to send survey notifications:", error.message);
    }
  } catch (err) {
    console.error("Failed to send survey notifications:", err);
  }
}
